import React from "react";
import FullHeight from "./hoc/FullHeight";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useResetForm } from "../hooks/useResetForm";
import { useBundleContext } from "../context/BundlesContext";
const SubmittedPage = () => {
  const { push } = useHistory();
  const { setSelectedBundle } = useBundleContext();

  const resetForm = useResetForm();
  function startOver() {
    setSelectedBundle(null);
    resetForm();
    push("new-order");
  }
  return (
    <FullHeight>
      <div className="d-flex align-items-center justify-content-center text-center flex-column h-100">
        <div
          className="align-items-center justify-content-center d-flex"
          style={{
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            border: "2px solid #ffad44",
            marginBottom: "2rem",
          }}
        >
          <Icon
            icon={["fal", "check"]}
            style={{ fontSize: "1.5rem", color: "#ffad44" }}
          />
        </div>
        <h1>Submission Complete!</h1>
        <h2
          className="text-muted"
          style={{ fontWeight: 200, fontSize: "1.75rem" }}
        >
          Your Realfoto order has been successfully submitted.
        </h2>
        <Button onClick={startOver}>Start Another Order</Button>
      </div>
    </FullHeight>
  );
};

export default SubmittedPage;
